import { Navigate, Outlet } from 'react-router-dom';
import { BLAUTHTOKEN, getDataFromStore } from '../../utils/CookiesUtils';

const AuthWrapper = () => {
  const isAuthenticated = getDataFromStore(BLAUTHTOKEN) !== null;
  
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AuthWrapper;